<template>
    <div class="unauth-user-list">
        <!-- 左边部门树 -->
        <div class="left-org">
          <div class="tit">
              业务分类
          </div>
          <div class="tree-body">
             <BusinessTree
                 :data="treeData"
                 :defaultProps="defaultProps"
                 @nodeClick="handleTreeNode"
             />
          </div>
        </div>
        <!-- 中间未授权人员列表 -->
        <div class="center-user">
              <div class="tit">
                  审批流
              </div>
              <div class="searchUn">
                <div class="tools-search" @keyup.enter="handleSearch">
                     <el-form :inline="true" class="demo-form-inline">
                        <el-form-item v-if="isDesign" label="审批类型" >
                          <el-input maxlength="60" style="width: 150px; " disabled v-model.trim="searchParams.busiTypeName">
                          </el-input>
                        </el-form-item>
                        <el-form-item v-else label="审批类型">
                             <BusinessTree
                                 ref="treeChild"
                                 v-if="isShowTree"
                                 :popover="true"
                                 :data="treeData"
                                 :defaultProps="defaultProps"
                                 @nodeClick="handleTreeNode"
                             />
                         </el-form-item>
                         <el-form-item label="模板名称">
                           <el-input maxlength="100" v-model.trim="searchParams.templateName" placeholder="">
                               <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                           </el-input>
                         </el-form-item>
                     </el-form>
                </div>
              </div>
              <div class="data-body">
                  <el-table :data="approvalTemplateLists" :border="true" v-loading="loading" :height="'51vh'" style="width: 100%;" @selection-change="handleSelectionApp">
                      <el-table-column
                        type="selection"
                        width="40">
                      </el-table-column>
                      <el-table-column
                        label="模板名称"
                        :show-overflow-tooltip="true"
                        align="center"
                        width="100">
                        <template slot-scope="scope">
                            <span style="font-weight: 700;color:#303133;font-size:16px;">{{ scope.row.templateName }}</span>
                        </template>
                      </el-table-column>
                       <el-table-column
                          v-if="!isDesign"
                          prop="busiTypeName"
                          width="100"
                          label="审批类型"
                          align="center"
                        >
                      </el-table-column>
                       <el-table-column
                        label="发布状态"
                        width="80">
                        <template slot-scope="scope">
                           <el-tag type="success" v-if="scope.row.templateState==1">已发布</el-tag>
                           <el-tag type="info"  v-else>未发布</el-tag>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="审批流顺序"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <el-steps v-if="scope.row.approvalMethod != 2 && scope.row.approvalTotalNum>0" :active="scope.row.approvalTotalNum" align-center>
                                <el-step v-for="(item, index) in scope.row.users" :key="index" :title="item.trueName"></el-step>
                            </el-steps>
                            <el-steps v-if="scope.row.approvalMethod == 2 && scope.row.approvalTotalNum>0" :active="scope.row.approvalTotalNum" align-center>
                                <el-step v-for="(item, index) in scope.row.approvalList"  :key="index" align-center >
                                    <el-breadcrumb v-if="item && item.length > 0" slot="title" :separator="(scope.row.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                        <el-breadcrumb-item  v-for="(user, i) in item" :key="i">{{user.trueName}}</el-breadcrumb-item>
                                    </el-breadcrumb>
                                </el-step>
                            </el-steps>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="已授权"
                        :show-overflow-tooltip="true"
                        align="left"
                        prop="processServiceUserNames"
                        width="130">
                      </el-table-column>
                    </el-table>
                    <el-row type="flex" justify="end" style="margin-top: 10px;">
                        <el-pagination
                            background
                            layout="total,sizes, prev, pager, next"
                            :total="pages.totalPageNum"
                            :current-page="pages.currentPage"
                            :page-size="pages.pageSize"
                            :page-sizes="[10, 20, 30, 50, 100]"
                            @current-change="queryFormData"
                            @size-change="queryFormDataByPageSize"
                        />
                    </el-row>
              </div>
        </div>
        <!-- 右边已选择人员列表 -->
        <div class="right-choose-user">
             <div class="tit">
                人员列表
             </div>
             <div class="data-body">
                <OrgUserTree @loadUserForms="loadUserForms" ref="orgUserTree" :showCheckbox="showCheckbox"></OrgUserTree>
             </div>
        </div>
    </div>
</template>

<script>
    import { isEmpty } from 'lodash';
    import {getApprovalTemplateList} from '@/data-model';
    import OrgUserTree from '@/components/OrgUserTree/OrgUserTree';
    export default{
        data () {
            return {
                showCheckbox: true,
                loading: false,
                approvalTemplateLists: [],
                pages: {
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    totalPageNum: 0 // 总页数
                },
                userId: [],
                forms: [],
                searchParams: {
                    busiType: '',
                    busiTypeName: '',
                    templateName: '',
                    templateState: null,
                    formId: ''
                }
            };
        },
        comments: {
            OrgUserTree
        },
        props: {
            treeData: {
                type: Array
            },
            defaultProps: {
                type: Object
            },
            permission: {
                type: Object
            },
            approvalTemplateList: {
                type: Array
            },
            isDesign: {
                type: Boolean,
                default: false
            }

        },
        created () {
            // this.approvalTemplateLists = this.approvalTemplateList;
            // this.pages = this.page;
            this.searchParams.busiType = '';
            this.handleSearch();
        },
        methods: {
            handleTreeNode (data, node, tree) {
                this.searchParams.busiType = data.id;
                this.searchParams.busiTypeName = data.label;
                this.handleSearch();
            },
            queryFormData (currentPage) {
                this.pages.currentPage = currentPage;
                this._getFormData();
            },
            queryFormDataByPageSize (pageSize) {
                this.pages.pageSize = pageSize;
                this._getFormData();
            },
            async _getFormData () {
                if (this.isSelect) {
                    this.pages.pageSize = 500;
                }
                if (!isEmpty(this.selectedTemplate)) {
                    this.approvalTemplateLists = this.selectedTemplate;
                    this.pages = {
                        currentPage: 1,
                        pageSize: this.selectedTemplate.length,
                        totalPageNum: this.selectedTemplate.length
                    };
                    if (this.selectedTemplate.length === 1) {
                        this.handleStartApproval(this.selectedTemplate[0]);
                    }
                } else {
                    this.loading = true;
                    this.searchParams.templateState = !this.isDesign ? 1 : null;
                    let formData = await getApprovalTemplateList(Object.assign({}, {
                        currentPage: this.pages.currentPage,
                        pageSize: this.pages.pageSize
                    }, this.searchParams));
                    if (formData) {
                        this.approvalTemplateLists = formData.data;
                        this.templateIds = formData.hasOwnProperty('otherData') ? formData.otherData.templeteIds : '';
                        this.pages = {
                            currentPage: formData.currentPage,
                            pageSize: formData.pageSize,
                            totalPageNum: formData.totalPageNum
                        };
                        // 转换showAllMyApprovals的值Integer为Boolean
                        this.approvalTemplateLists.forEach(element => {
                            element.showAllMyApprovals = (element.showAllMyApprovals > 0);
                        });
                    }
                    this.loading = false;
                }
            },
            loadUserForms (obj) {
                let userids = [];
                for (var i = 0; i < obj.length; i++) {
                    userids.push(obj[i].id);
                }
                this.userId = userids.join(',');
            },
            handleSearch () {
                this.queryFormData(1);
            },
            handleSelectionApp (rows) {
                let processServiceId = [];
                for (var i = 0; i < rows.length; i++) {
                    processServiceId.push(rows[i].id);
                }
                this.forms = processServiceId.join(',');
            },
            buildParam () {
                let param = {userId: this.userId, processServiceId: this.forms};
                return param;
            }
        }
    };
</script>

<style lang="less" scoped>
.unauth-user-list{
    height: 70vh;
    display: flex;
    .left-org{
       width: 20vw;
       height: 100%;
       overflow: auto;
       border: 1px solid #F0F0EE;
       .search-content{
           width: 92%;
           margin-left: 2%;
       }
       .tit{
           height: 6vh;
           text-align: center;
           font-size: 1.25vw;
           line-height: 6vh;
       }
    }
    .center-user{
       width: 60vw;
       margin-left:2vw;
       height: 100%;
       overflow: auto;
       border: 1px solid #F0F0EE;
       .tit{
           height: 6vh;
           text-align: center;
           font-size: 1.25vw;
           line-height: 6vh;
       }
       .search-content{
           width: 92%;
           margin-left: 2%;
           margin-bottom: 1vh;
       }
       .unUserTable{
           width: 96%;
           margin-left: 2%;
           .gutter{
               width: 14px!important;
           }
           .el-table--border{
               border: none!important;
           }
           .el-table--group{
               border: none!important;
           }

       }

    }
    .right-choose-user{
       width: 20vw;
       margin-left: 2vw;
       border: 1px solid #F0F0EE;
       height: 100%;
       overflow: auto;
       .tit{
           height: 6vh;
           text-align: center;
           font-size: 1.25vw;
           line-height: 6vh;
       }
       .unChooseUserTable{
           width: 96%;
           margin-left: 2%;
           .gutter{
               width: 14px!important;
           }
           .el-table--border{
               border: none!important;
           }
           .el-table--group{
               border: none!important;
           }
       }
       .data-body{
           /deep/ .tree-body{
               border: none;
               height: 100%;
           }
       }
    }

}
.dialog__body{
    padding-top: 10px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/ApproveBatchAuth/ApproveBatchAuth.vue